import styled from 'styled-components';
import { TextareaAutosize as MatTextareaAutosize } from '@material-ui/core';


export const UiIconTextAreaMain = styled.div`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
`;

export const UiIconTextArea = styled.label`
	position: relative;
	display: flex;
	align-items: center;
	overflow: hidden;
	padding: 0.25rem;
	width: 100%;
	background-color: #f2f3f5;
	border: 1px solid rgba(42, 72, 101, 0.3);
	border-radius: 18px;
	flex: 1;
	flex-wrap: wrap;
	letter-spacing: 1px;
`;

export const UiIconTextAreaInput = styled(MatTextareaAutosize)`
	position: relative;
	overflow-x: hidden;
	padding: 4px 12px;
	width: 95%;
	font-size: 1rem;
	white-space: pre-wrap;
	background-color: transparent;
	border: none;
	outline: none;
	resize: none;
`;

export const UiIconTextAreaBox = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`;

export const UiIconFileBox = styled.label`
	position: absolute;
	top: 65%;
	right: 0;
	transform: translateY(-60%);

	& > input {
		display: none;
	}

	& > svg {
		margin: 0 0.5rem;
		font-size: 1.4rem;
		color: #999;
		transition: 0.35s;
		cursor: pointer;

		&:hover {
			color: #ccc;
			background-color: #00828f;
		}
	}
`;

export const UiFiles = styled.div`
	display: flex;
	justify-content: space-between;
	overflow: hidden;
	margin: 0.5rem 0;
	padding: 0.5rem;
	width: 100%;
	background-color: ${({ theme }) => theme.palette.background.main};
	border-radius: 5px;

	& > svg {
		font-size: 1rem;
		cursor: pointer;
	}
`;
